import uuid from 'react-native-uuid';

type CryptoWithRandomUUID = {
  randomUUID?: () => string;
};

export const createAIResponseId = (): string => {
  const cryptoObject = (globalThis as unknown as { crypto?: CryptoWithRandomUUID })
    .crypto;
  const nativeId = cryptoObject?.randomUUID?.();

  return nativeId ?? String(uuid.v4());
};
